module.exports = __webpack_public_path__ + "static/media/Obligations_Assujetis_Assurance.575ad1e2.pdf";